export default function NewSyncableEndnoteChangeController(
) {
  const vm = this;

  _activate();

  function _activate() {
    console.log(vm);
  }
}

NewSyncableEndnoteChangeController.$inject = [
];
